import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetVehicleInfoVehiclesService extends Service {
  constructor({
    config,
    fromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper,
    getCompetitorsVehiclesService,
    httpVehiclesRepository,
    vehicleEntityFactory
  }) {
    super()
    this._config = config
    this._getCompetitorsService = getCompetitorsVehiclesService
    this._httpRepository = httpVehiclesRepository
    this._mapper = fromVehicleInfoValueObjectToVehicleInfoWithCompetitorsValueObjectMapper
    this._vehicleEntityFactory = vehicleEntityFactory
    this._appName = this._config.get('APP_NAME')
    this._appNameCoches = this._config.get('APP_NAME_COCHES')
    this._isCoches = this._appName === this._appNameCoches
    const {TECHNICAL_DETAILS_VEHICLE_PAGE_NAME} = this._config.get('page')
    this._technicalDetailsVehiclePage = TECHNICAL_DETAILS_VEHICLE_PAGE_NAME
  }

  @inlineError
  async execute({pageName, competitors = false, grouped = false, make, model, vehicleId}) {
    const isTechnicalDetailsVehicle = pageName === this._technicalDetailsVehiclePage
    const isUseVehicleVersionDetailEndpoint = this._isCoches && isTechnicalDetailsVehicle
    const getVehicleInfoFn = isUseVehicleVersionDetailEndpoint
      ? this._httpRepository.getVehicleInfoV2
      : this._httpRepository.getVehicleInfo

    const [getVehicleInfoError, getVehicleInfoResponse] = await getVehicleInfoFn({
      grouped,
      make,
      model,
      vehicleId
    })
    if (getVehicleInfoError) return Promise.reject(getVehicleInfoError)

    if (!competitors) return getVehicleInfoResponse

    const vehicleEntity = this._vehicleEntityFactory({id: vehicleId})

    const [getCompetitorsError, getCompetitorsResponse] = await this._getCompetitorsService.execute({vehicleEntity})

    if (getCompetitorsError) return Promise.reject(getCompetitorsError)

    const vehicleInfoWithCompetitorsVO = this._mapper.map({
      vehicleInfoValueObject: getVehicleInfoResponse,
      competitorsValueObject: getCompetitorsResponse
    })

    return vehicleInfoWithCompetitorsVO
  }
}
